<template>
  <div>
    <a-row style="margin: 40px 0px 0px 0px">
      <a-col :span="14">
        <a-carousel
          v-if="housePicList.length"
          arrows
          dots-class="slick-dots slick-thumb"
          style="margin-bottom: 50px"
        >
          <a slot="customPaging" slot-scope="props">
            <img :src="getImgUrl(props.i)" />
          </a>

          <div v-for="(item, index) in housePicList" :key="index">
            <img :src="buildImgUrl(item)" />
          </div>
        </a-carousel>
        =
      </a-col>

      <a-col :span="10">
        <div class="price-block">
          <span class="price-label">出租底价</span>
          <span class="price-value">{{ floorPriceText }}</span>
          <span class="price-unit">{{ floorPriceUnitText }}</span>
        </div>

        <div class="status-wrap">
          <span class="status-tag">
            <span class="status-tag-text">意向发布</span>
          </span>
        </div>

        <div class="feature-tags">
          <span class="feature-tag">国企认证</span>
          <span class="feature-tag">信息公开透明</span>
          <span class="feature-tag">提前预约随时可看</span>
          <span v-if="showFloorPriceTip" class="feature-tag">
            出租底价仅向报名的意向承租方公开
          </span>
        </div>

        <div class="split-divider-wrap">
          <a-divider />
        </div>

        <div class="summary-grid">
          <div class="summary-item">
            <span class="summary-item-label">出租面积：</span>
            <span class="summary-item-value">{{ leaseAreaText }}</span>
          </div>

          <div class="summary-item">
            <span class="summary-item-label">租赁期限：</span>
            <span class="summary-item-value">{{ leaseTermText }}</span>
          </div>

          <div class="summary-item">
            <span class="summary-item-label">免租期限：</span>
            <span class="summary-item-value">{{ rentFreePeriodText }}</span>
          </div>
        </div>

        <div class="split-divider-wrap">
          <a-divider />
        </div>

        <div class="base-info-list">
          <div class="base-info-row">
            <span class="base-info-label">地址：</span>
            <span class="base-info-value">{{ addressText }}</span>
          </div>

          <div class="base-info-row">
            <span class="base-info-label">招租公告起始日期：</span>
            <span class="base-info-value">{{ disclosureStartDateText }}</span>
          </div>

          <div class="base-info-row">
            <span class="base-info-label">招租公告截止日期：</span>
            <span class="base-info-value">{{ disclosureEndDateText }}</span>
          </div>

          <div class="base-info-row">
            <span class="base-info-label">项目负责人：</span>
            <span class="base-info-value">盛思敏</span>
          </div>

          <div class="base-info-row">
            <span class="base-info-label">负责人联系电话：</span>
            <span class="base-info-value">
              <img src="@/assets/phone2.png" alt="" class="phone-icon" />
              021-57311423
            </span>
          </div>

          <div class="base-info-row" v-if="intentLeaseInfo.hasPayBond == 1">
            <span class="base-info-label">保证金金额：</span>
            <span class="base-info-value">{{ bondAmountText }}</span>
          </div>

          <div class="contact-platform-wrap">
            <a-button
              type="primary"
              class="platform-btn"
              @click="getContactInfo"
            >
              联系出租方
            </a-button>

            <div class="platform-tip">
              填写联系信息后，方可查看出租方联系电话
            </div>
          </div>
        </div>
      </a-col>
    </a-row>

    <a-modal
      title="请填写您的报名信息"
      :visible="contactModalVisible"
      :footer="null"
      width="500px"
      @cancel="closeContactModal"
    >
      <a-form-model
        ref="contactForm"
        :model="contactForm"
        :rules="contactRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="意向方名称" prop="name" class="password-item">
          <a-input v-model="contactForm.name" placeholder="请输入意向方名称" />
        </a-form-model-item>

        <a-form-model-item label="手机号" prop="phone" class="password-item">
          <a-input
            v-model="contactForm.phone"
            placeholder="请输入手机号"
            maxlength="11"
          />
        </a-form-model-item>

        <a-form-model-item label="备注" prop="remark" class="password-item">
          <a-input v-model="contactForm.remark" placeholder="请输入备注" />
        </a-form-model-item>

        <div class="contact-modal-footer">
          <a-button @click="closeContactModal">取消</a-button>
          <a-button
            type="primary"
            class="modal-confirm-btn"
            :loading="contactSubmitLoading"
            @click="submitContactInfo"
          >
            确定
          </a-button>
        </div>
      </a-form-model>
    </a-modal>

    <a-modal
      title="出租方联系方式"
      :visible="landlordModalVisible"
      :footer="null"
      width="420px"
      @cancel="closeLandlordModal"
    >
      <div class="landlord-contact-content">
        <div class="landlord-contact-row">
          <span class="landlord-contact-label">联系人姓名：</span>
          <span class="landlord-contact-value">{{
            intentLeaseInfo.lessorContact
          }}</span>
        </div>

        <div class="landlord-contact-row">
          <span class="landlord-contact-label">联系电话：</span>
          <span class="landlord-contact-value">{{
            intentLeaseInfo.lessorContactPhone
          }}</span>
        </div>

        <div class="landlord-contact-footer">
          <a-button class="landlord-close-btn" @click="closeLandlordModal">
            关闭
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  name: "BidApplyTopInfo",

  props: {
    housePic: {
      type: Array,
      default: () => [],
    },
    intentLeaseInfo: {
      type: Object,
      default: () => ({}),
    },
    houseBaseInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      contactModalVisible: false,
      contactSubmitLoading: false,
      contactForm: {
        name: "",
        phone: "",
        remark: "",
      },
      contactRules: {
        name: [
          { required: true, message: "请输入意向方名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
      },
      landlordModalVisible: false,
    };
  },

  computed: {
    housePicList() {
      return Array.isArray(this.housePic) ? this.housePic.filter(Boolean) : [];
    },

    floorPriceText() {
      const type = Number(this.intentLeaseInfo.listingPriceType);

      if (type === 1) {
        return this.formatMoney(this.intentLeaseInfo.listingPrice);
      }

      if (type === 2) {
        const min = this.intentLeaseInfo.listingPriceDown;
        const max = this.intentLeaseInfo.listingPriceUp;

        if (!this.hasValue(min) && !this.hasValue(max)) {
          return "--";
        }

        if (this.hasValue(min) && this.hasValue(max)) {
          return `${this.formatMoney(min)} - ${this.formatMoney(max)}`;
        }

        if (this.hasValue(min)) {
          return `${this.formatMoney(min)} 起`;
        }

        return `${this.formatMoney(max)} 以内`;
      }

      return this.formatMoney(this.intentLeaseInfo.intentLeaseInfo);
    },

    floorPriceUnitText() {
      const map = {
        1: "元/月",
        2: "元/年",
        3: "元/天/平方米",
        4: "元/月/平方米",
      };

      return map[this.intentLeaseInfo.listingPriceUnit] || "元/年";
    },

    leaseAreaText() {
      const value = this.houseBaseInfo.leaseArea;
      return this.hasValue(value) ? `${value} ㎡` : "--";
    },

    leaseTermText() {
      const type = Number(this.intentLeaseInfo.leaseTermType);

      const map = {
        1: "个月",
        2: "年",
      };

      const unit = map[this.intentLeaseInfo.leaseTermUnit] || "";

      // 固定
      if (type === 1) {
        return this.hasValue(this.intentLeaseInfo.leaseTerm)
          ? `${this.intentLeaseInfo.leaseTerm}${unit}`
          : "--";
      }

      // 区间
      if (type === 2) {
        const min = this.intentLeaseInfo.leaseTermMin;
        const max = this.intentLeaseInfo.leaseTermMax;

        if (!this.hasValue(min) && !this.hasValue(max)) {
          return "--";
        }

        return `${min || "--"} 至 ${max || "--"}${unit}`;
      }

      return "--";
    },

    rentFreePeriodText() {
      const value = this.intentLeaseInfo.rentFreePeriod;
      const unit = this.intentLeaseInfo.rentFreePeriodUnit;

      if (!this.hasValue(value)) {
        return "--";
      }

      const map = {
        1: "天",
        2: "个月",
      };

      return `${value} ${map[unit] || ""}`;
    },

    addressText() {
      return this.formatEmpty(this.houseBaseInfo.housingResAddress);
    },

    disclosureStartDateText() {
      return this.formatEmpty(
        this.intentLeaseInfo.disclosureStartDate ||
          this.intentLeaseInfo.disclosureStartTime ||
          this.intentLeaseInfo.publicStartDate ||
          this.intentLeaseInfo.noticeStartDate
      );
    },

    disclosureEndDateText() {
      return this.formatEmpty(
        this.intentLeaseInfo.disclosureEndDate ||
          this.intentLeaseInfo.disclosureEndTime ||
          this.intentLeaseInfo.publicEndDate ||
          this.intentLeaseInfo.noticeEndDate
      );
    },

    projectLeaderText() {
      return this.formatEmpty(
        this.intentLeaseInfo.projectLeader ||
          this.intentLeaseInfo.projectContact ||
          this.intentLeaseInfo.contactPerson ||
          this.intentLeaseInfo.contactName
      );
    },

    contactPhoneText() {
      return this.formatEmpty(
        this.intentLeaseInfo.contactPhone ||
          this.intentLeaseInfo.projectContactPhone ||
          this.intentLeaseInfo.phone ||
          this.intentLeaseInfo.contactTel
      );
    },

    bondAmountText() {
      const value = this.intentLeaseInfo.bondAmount;
      return this.hasValue(value) ? `${value} 元` : "无需保证金";
    },

    showFloorPriceTip() {
      // 后续如果有“底价是否公开”字段，可以在这里调整
      // 例如：return this.intentLeaseInfo.floorPriceOpenFlag !== 1
      return true;
    },
  },

  methods: {
    hasValue(value) {
      return value !== undefined && value !== null && value !== "";
    },

    formatEmpty(value) {
      return this.hasValue(value) ? value : "--";
    },

    buildImgUrl(url) {
      if (!url) {
        return "";
      }

      if (url.indexOf("?") > -1) {
        return url;
      }

      return `${url}?x-oss-process=image/resize,l_1000`;
    },

    getImgUrl(i) {
      return this.buildImgUrl(this.housePicList[i]);
    },

    formatMoney(value) {
      if (!this.hasValue(value)) {
        return "--";
      }

      const num = Number(value);

      if (Number.isNaN(num)) {
        return value;
      }

      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    getContactInfo() {
      // 判断是否登录
      const token = storage.get(ACCESS_TOKEN);

      if (!token) {
        this.$warning({
          title: "提示",
          content: "请先登录后再查看出租方联系方式",
        });
        return;
      }

      this.contactModalVisible = true;
      this.$nextTick(() => {
        this.$refs.contactForm && this.$refs.contactForm.clearValidate();
      });
    },

    closeContactModal() {
      this.contactModalVisible = false;
    },

    submitContactInfo() {
      this.$refs.contactForm.validate((valid) => {
        if (!valid) {
          return;
        }

        this.contactSubmitLoading = true;
        // todo
        // 后续这里换成真实接口
        // saveContactInfo({
        //   bizWebId: this.intentLeaseInfo.webId,
        //   name: this.contactForm.name,
        //   phone: this.contactForm.phone,
        //   remark: this.contactForm.remark,
        // }).then((res) => {
        //   this.landlordContact.name = res.data.contactName;
        //   this.landlordContact.phone = res.data.contactPhone;
        //   this.contactModalVisible = false;
        //   this.landlordModalVisible = true;
        // }).finally(() => {
        //   this.contactSubmitLoading = false;
        // });

        this.contactModalVisible = false;
        this.landlordModalVisible = true;
        this.contactSubmitLoading = false;
      });
    },

    closeLandlordModal() {
      this.landlordModalVisible = false;
    },
  },
};
</script>

<style scoped>
/* For demo */
.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border-radius: 12px;
  height: 500px;
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 80%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  border-radius: 3px;
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}
</style>

<style lang="less" scoped>
.price-block {
  margin-bottom: 8px;
}

.price-label {
  font-weight: 700;
  font-size: 22px;
  font-family: Arial;
  color: #333333;
}

.price-value {
  margin-left: 8px;
  font-weight: 700;
  font-size: 28px;
  font-family: Arial;
  color: #ff0214;
}

.price-unit {
  margin-left: 4px;
  font-weight: 700;
  font-size: 24px;
  font-family: Arial;
  color: #ff0214;
}

.status-wrap {
  margin-top: 4px;
}

.status-tag {
  display: inline-block;
  background: linear-gradient(135deg, #1677ff, #4096ff);
  border-radius: 5px;
  line-height: 1;
}

.status-tag-text {
  font-weight: 500;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #f7f7f7;
  margin: 4px 8px;
  display: inline-block;
}

.feature-tags {
  margin: 10px 0 0;
}

.feature-tag {
  background-color: #f1f5f8;
  color: #819aae;
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  margin: 4px 6px 4px 0;
}

.split-divider-wrap {
  width: 88%;
  margin-top: -10px;
}

.summary-grid {
  display: flex;
  flex-wrap: wrap;
}

.summary-item {
  width: 50%;
  margin-bottom: 12px;
}

.summary-item-label {
  font-size: 18px;
  color: #666666;
  font-family: Microsoft YaHei;
}

.summary-item-value {
  font-size: 20px;
  color: #3072f6;
  font-family: Microsoft YaHei;
  font-weight: 600;
}

.base-info-list {
  width: 100%;
}

.base-info-row {
  margin-bottom: 12px;
}

.base-info-label {
  font-size: 16px;
  color: #999999;
  font-family: Microsoft YaHei;
}

.base-info-value {
  font-size: 16px;
  color: #333333;
  font-family: Microsoft YaHei;
}

.phone-icon {
  height: 16px;
  vertical-align: middle;
  margin-right: 4px;
}

.contact-platform-wrap {
  margin-top: 20px;
  width: 88%;
  border-radius: 4px;
  text-align: center;
  padding: 14px;
}

.platform-btn {
  width: 220px;
  height: 44px;
  font-size: 16px;
  border-radius: 4px;
}

.platform-tip {
  margin-top: 12px;
  font-size: 14px;
  color: #ff4d4f;
}

.contact-modal-footer {
  text-align: center;
  margin-top: 22px;

  .ant-btn {
    width: 112px;
    height: 36px;
    margin: 0 6px;
  }
}

/* 输入框高度统一 */
.password-item /deep/ .ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.landlord-contact-content {
  text-align: center;
  padding: 6px 0 4px;
}

.landlord-contact-row {
  margin-bottom: 12px;
  font-size: 14px;
}

.landlord-contact-label {
  color: #666666;
}

.landlord-contact-value {
  color: #333333;
}

.landlord-contact-footer {
  margin-top: 24px;
}

.landlord-close-btn {
  width: 112px;
  height: 36px;
}
</style>